/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ListLogAnalyticsWorkspaceRequest {
    getFixupPrototypeFunction() { return ListLogAnalyticsWorkspaceRequest.fixupPrototype; }

    static newInstance(model: Partial<ListLogAnalyticsWorkspaceRequest>): ListLogAnalyticsWorkspaceRequest {
        let obj = Object.assign(new ListLogAnalyticsWorkspaceRequest(), model);
        ListLogAnalyticsWorkspaceRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ListLogAnalyticsWorkspaceRequest>): ListLogAnalyticsWorkspaceRequest {
        if (!model) return null;
        return ListLogAnalyticsWorkspaceRequest.newInstance(<ListLogAnalyticsWorkspaceRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ListLogAnalyticsWorkspaceRequest) {
        if (!obj) return;

        models.ListLogAnalyticsWorkspaceRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ListLogAnalyticsWorkspaceRequest): boolean {
        Object.setPrototypeOf(obj, ListLogAnalyticsWorkspaceRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * list of all tenant ids for which log analytics workspace details are required
     */
    tenant_ids: Array<string>;

    /**
     * list of service account ids for which log analytics workspace details are required
     */
    service_account_ids: Array<string>;

}
